module.exports = __webpack_public_path__ + "static/media/Pod_Belegrady.77806df8.md";